import { lazy, Suspense, useEffect, useState } from "react";
import { OPEN_DATA_ENTRY_EVENT, registerDataEntryLauncher, type OpenDataEntryDetail } from "./dataEntryLauncher";

const DataEntryAgent = lazy(() => import("./DataEntryAgent"));

/**
 * Mounted once in the shell: opens the «הזנה חכמה» sheet when anything asks for it
 * (openDataEntryAgent) — only for a user who may use it (the server checks again on every call).
 */
export function DataEntryLauncherHost({ enabled }: { enabled: boolean }) {
  const [open, setOpen] = useState<OpenDataEntryDetail | null>(null);
  useEffect(() => {
    if (!enabled) return undefined;
    const unregister = registerDataEntryLauncher();
    const onOpen = (e: Event) => setOpen((e as CustomEvent<OpenDataEntryDetail>).detail ?? {});
    window.addEventListener(OPEN_DATA_ENTRY_EVENT, onOpen);
    return () => {
      unregister();
      window.removeEventListener(OPEN_DATA_ENTRY_EVENT, onOpen);
    };
  }, [enabled]);
  if (!open || !enabled) return null;
  return (
    <Suspense fallback={null}>
      <DataEntryAgent
        key={open.sessionId ?? "new"}
        open
        initialType={open.importType ?? null}
        sessionId={open.sessionId ?? null}
        onClose={() => setOpen(null)}
      />
    </Suspense>
  );
}
